import { FluxType } from 'flux/buildFlux';
import { WlWindow } from 'typings/globals/cordova';

import CordovaServices from './cordova';
import init from './init';
import RateAppManager from './services/RateAppManager';

declare const window: WlWindow;

export const flux: FluxType = init();

export const appServices = CordovaServices(flux);

let storage = null;
try {
  storage = window.localStorage;
} catch (e) {}

export const rateAppManager = new RateAppManager(storage);
